const _ = require('lodash');
const stk500v2org = require('stk500-v2');
const hex = require('./intel-hex');
const Promise = require('bluebird');
import Logger from '../../util/logger';

let firmwarev2 = function (serialPort, data, progressHandle, callback) {

    let currentStatus = true;
    let pageSize = 256;
    let openSerialPort, closeSerialPort;
    openSerialPort = Promise.promisify((cb) => {

        Logger.info('open ok ,callback', serialPort);
        cb(null, serialPort);
    });
    closeSerialPort = () => {
    };

    let options = {
        timeout: 0xc8,
        stabDelay: 0x64,
        cmdexeDelay: 0x19,
        synchLoops: 0x20,
        byteDelay: 0x00,
        pollValue: 0x53,
        pollIndex: 0x03
    };
    let stk500v2OrgInstance = stk500v2org(serialPort);
    let stk500v2 = _.extend({}, stk500v2OrgInstance, {
        sync: function (attempts, done) {
            this.progressHandle = progressHandle;
            this.length = -1;
            this.progress = -1;
            this.baseProgress = -1;
            Logger.info('stk500v2Instance sync');
            stk500v2OrgInstance.sync.call(this, attempts, done);
        },
        loadAddress: function (useaddr, done) {
            var pageaddr = useaddr << 1;
            var progress = this.baseProgress + (Math.round(pageaddr * 100 / this.length));
            if (this.progress !== progress) {
                this.progress = progress;
                var _this = this;
                this.progressHandle && setTimeout(function () {
                    _this.progressHandle(progress);
                }, 0);
            }
            stk500v2OrgInstance.loadAddress.call(this, useaddr, function (err, result) {
                // Logger.info('sync done');
                done(err, result);
            });
        },
        upload: function (hex, pageSize, done) {
            this.baseProgress = 0;
            this.length = hex.length;
            stk500v2OrgInstance.upload.call(this, hex, pageSize, done);
        },
    });

    let setSerialPort = Promise.promisify(serialPort.set.bind(serialPort));
    let sync = Promise.promisify(stk500v2.sync.bind(stk500v2));
    let enterProgrammingMode = Promise.promisify(stk500v2.enterProgrammingMode.bind(stk500v2));
    let upload = Promise.promisify(stk500v2.upload.bind(stk500v2));
    let exitProgrammingMode = Promise.promisify(stk500v2.exitProgrammingMode.bind(stk500v2));

    setTimeout(() => {
        var promiseHex = Promise.join(
            (function () {
                return hex.parse(data).data;
            })(),

            openSerialPort()
                .then(function () {
                    Logger.info('open serial port ok');
                })
                .delay(1)//以下几步设置串口发送位
                .then(function () {
                    return setSerialPort({
                        rts: true,
                        dtr: true
                    });
                })
                .delay(1)
                .then(function () {
                    return setSerialPort({
                        rts: false,
                        dtr: false
                    });
                })
                .delay(1)
                .then(function () {
                    return setSerialPort({
                        rts: true,
                        dtr: true
                    });
                })
                .delay(1)
                .then(function () {
                    Logger.info('begin sync');
                    return sync(5);
                })
                .delay(1)
                .then(function () {//下位机同步,并进入编程模式上
                    Logger.info('syn ok');
                    return enterProgrammingMode(options);
                })
                .delay(1),

            function (hex) {
                return hex;
            });

        promiseHex.then(function (hex) { //上传hex
            return upload(hex, pageSize);
        })
            .then(function () {
                return exitProgrammingMode(); //退出编程模式
            })
            .then(function () {
                return setSerialPort({
                    rts: false,
                    dtr: false
                });
            })
            .then(() => {
                closeSerialPort();
                callback(null, currentStatus);
            })
            .catch(e => {
                console.log('error: ', e);
                closeSerialPort();
                callback(e, null);
            });
    }, 600);
};

export default firmwarev2;
